import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetReadingsByUserIdQuery } from '../../../generated/graphql'
import { RootState } from '../../../store'

export type SyncedReading = GetReadingsByUserIdQuery['readings'][0]

type ReadingsSyncState = {
  byId: Record<string, SyncedReading>
}

const initialState: ReadingsSyncState = {
  byId: {},
}

export const readingsSyncSlice = createSlice({
  name: 'readingsSync',
  initialState,
  reducers: {
    upsertSyncedReading: (state, { payload }: PayloadAction<SyncedReading>) => {
      if (!payload?.id) {
        return
      }

      state.byId[payload.id] = payload
    },
    upsertManySyncedReadings: (
      state,
      { payload }: PayloadAction<SyncedReading[]>,
    ) => {
      payload.forEach((reading) => {
        if (reading?.id) {
          state.byId[reading.id] = reading
        }
      })
    },
    clearSyncedReadings: (state) => {
      state.byId = {}
    },
  },
})

export const {
  upsertSyncedReading,
  upsertManySyncedReadings,
  clearSyncedReadings,
} = readingsSyncSlice.actions

export const selectSyncedReadingsById = ({ readingsSync }: RootState) => {
  return readingsSync.byId
}

export const selectSyncedReadingById = (
  { readingsSync }: RootState,
  readingId?: string,
) => {
  if (!readingId) {
    return undefined
  }

  return readingsSync.byId[readingId]
}

export const selectResolvedReading = <T extends { id: string }>(
  { readingsSync }: RootState,
  reading: T,
) => {
  return (readingsSync.byId[reading.id] as unknown as T) || reading
}
